import React from 'react';
import EventsPage from  '../components/EventsPage/EventsPage';

export default function Events() {
    return (
        <div>
           <EventsPage /> 
        </div>
    )
}
